import Helper from "@ember/component/helper";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";

type Positional = Array<BioExamResultsReceivedJournalEvent>;

export interface CountAdhocResultsSignature {
  Args: {
    Positional: Positional;
  };
  Return: number;
}

export default class extends Helper<CountAdhocResultsSignature> {
  override compute([bioExamResultsJe]: [BioExamResultsReceivedJournalEvent]) {
    return bioExamResultsJe.bioExamResults.filter(
      bioExamResult => bioExamResult.isAdhoc
    ).length;
  }
}
